import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/** In-app Help (2026-09-28): the Confluence User Guide, mirrored hourly
 *  by the worker into help_pages so users without a Confluence login can
 *  read it here. Confluence stays the place to edit. */
export interface HelpPage {
  page_id: string;
  parent_id: string | null;
  slug: string;
  title: string;
  /** 0 = the guide's front page; 1..n = the numbered sections. */
  section: number | null;
  position: number;
  version: number | null;
  web_url: string | null;
  synced_at: string | null;
  html: string;
}

export function useHelpPages() {
  return useQuery<HelpPage[]>({
    queryKey: ["help-pages"],
    queryFn: () => api.get("/help/").then((r) => r.data),
    staleTime: 5 * 60_000,
  });
}
